import { setupWorker } from 'msw';
import TransactionsHandler from './handlers/transactionHandlers';
import TroncHandler from './handlers/troncHandlers';
import NotificationsMenuHandlers from './handlers/notificationsMenuHandlers';
import CompanyConfigHandler from './handlers/companyConfigHandlers';
import DashboardHandler from './handlers/dashboardHandlers';
import IndicatorsHandler from './handlers/indicatorsHandlers';
import UserHandler from './handlers/userHandlers';
import SettingHander from './handlers/settingsHandler';
import GlobalSearchHandlers from './handlers/globalSearchHandler';
import NotificationsHandlers from './handlers/notificationsHandlers';
import PromotionalBannerHandlers from './handlers/promotionalBannerHandler';
import ReportOverviewHandlers from './handlers/reportOverviewHandlers';
import GeneratedReportsHandlers from './handlers/generatedReportsHandlers';
// This configures a Service Worker with the given request handlers.
// ultimately these get swapped out with real APIs

const worker =
  setupWorker(
  // ...UserHandler,
  // ...TransactionsHandler,
  // ...TroncHandler,
  // ...NotificationsMenuHandlers,
  // ...DashboardHandler,
  // ...IndicatorsHandler,
  // ...CompanyConfigHandler,
  // ...SettingHander,
  // ...GlobalSearchHandlers,
  // ...NotificationsHandlers,
  // ...PromotionalBannerHandlers,
  // ...ReportOverviewHandlers,
  // ...GeneratedReportsHandlers
);

export default worker;
